import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=55e5d482&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"
import style0 from "./InputFile.vue?vue&type=style&index=0&id=55e5d482&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5d482",
  null
  
)

export default component.exports